import type { Future, Handler, NextFn } from '@warp-drive/core/request';
import type {
  RequestContext,
  StructuredDataDocument,
} from '@warp-drive/core/types/request';

export class DebugHandler implements Handler {
  request<T = unknown>(
    context: RequestContext,
    next: NextFn<T>
  ): Promise<T | StructuredDataDocument<T>> | Future<T> {
    return next({ ...context.request });
  }
}
